import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/404',
      name: '404',
      component: require('@/pages/common/404')
    },
    {
      path: '*',
      redirect: '404'
    },
    {
      path: '/',
      name: 'Index',
      component: require('@/pages/common/index')
    },
    {
      path: '/kobenhavn',
      name: 'Koebenhavn',
      component: require('@/pages/retailers/koebenhavn/14062018/index'),
      meta: { retailerName: 'København' }
    },
    {
      path: '/amager',
      name: 'Amager',
      component: require('@/pages/retailers/amager/19042018/index'),
      meta: { retailerName: 'Amager' }
    },
    {
      path: '/gladsaxe',
      name: 'Gladsaxe',
      component: require('@/pages/retailers/gladsaxe/29082018/index'),
      meta: { retailerName: 'Gladsaxe' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js